<template>
	<div class="content" style="background-color: #103037; border-radius: 15px;padding: 20px 0px">
		<div class="md-layout">
			<div class="md-layout-item md-small-size-10 md-medium-size-20 md-size-33"></div>
			<div class="md-layout-item md-small-size-80 md-medium-size-60 md-size-33">
				<loading v-if="!loaded" />
				<div class="form__tabs__wrap" v-if="loaded">
					<form @submit.prevent="register()">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input type="text" v-model="user.name" :placeholder="$store.state.lang.text.fullname[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input type="text" v-model="user.phone" :placeholder="$store.state.lang.text.phone[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input type="text" v-model="user.username" :placeholder="$store.state.lang.text.username[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input v-model="user.password" type="password" :placeholder="$store.state.lang.text.password[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
								<div class="form__grp" style="margin-top: 18px"><input v-model="user.confirm_password" type="password" :placeholder="$store.state.lang.text.confirm_password[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100" style="margin-top: 10px">
								<div class="create__btn">
									<a class="cmn--btn" @click="register()">
										<span>{{$store.state.lang.text.register[$store.state.lang.language]}}</span>
									</a>
								</div>
							</div>
							<!-- <div class="md-layout-item md-small-size-70 md-medium-size-70 md-size-70">
								<div class="form__grp" style="margin-top: 18px"><input v-model="user.verification_code" type="password" :placeholder="$store.state.lang.text.security_number[$store.state.lang.language]"></div>
							</div>
							<div class="md-layout-item md-small-size-30 md-medium-size-30 md-size-30" style="display: flex; justify-content: center;align-items: center;margin-top: 18px">{{user.code}}</div>
							<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100" style="display: flex; justify-content: center;align-items: center;margin-top: 18px">{{message}}</div> -->
						</div>

					</form>
			   </div>



			</div>
			<div class="md-layout-item md-medium-size-25 md-size-33"></div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {

			if(this.$store.state.authentication.loggedIn) {
				this.$router.push("/");
			}  else {
				this.getForm();
			}
			// this.$http.get(this.config.api + "/admin/get/stat").then(data => {
			// 	this.stat = data.body.data
			// 	this.loaded = true;
			// });
			// this.getToday();
			// this.getMonth();
		},
		methods: {
			getForm() {
				this.$http.get(this.config.api + "/user/request_form").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.user.token = res.body.data.token
						this.user.code = res.body.data.code
						this.user.verification_code = res.body.data.code
					}
				})
			},
			register() {
				if(this.user.username.length > 3 && this.user.password.length > 4 && this.user.confirm_password.length > 4 && this.user.password == this.user.confirm_password && String(this.user.verification_code).length > 4) {
					let password = this.user.password;
					this.user.password = "";
					this.$http.post(this.config.api + "/user/register", {
						username: this.user.username,
						password: password,
						confirm_password: this.user.confirm_password,
						name: this.user.name,
						phone: this.user.phone,
						token: this.user.token,
						referral: this.config.getCookie("referral") != "" ? this.config.getCookie("referral") : null,
						verification_code: this.user.verification_code
					}).then(res => {

						if (res.body.status == 'success') {
							this.$store.state.authentication.loggedIn = true;
							this.$store.state.authentication.authToken = res.body.data.token;
							this.$cookie.set('auth', res.body.data.token, 1);
							this.$notification.notify(this.$store.state.lang.text.done_register[this.$store.state.lang.language])
							this.$router.push("/");
						} else {
							// this.user.verification_code = ""
							this.getForm();
						}
					})
				} else {
					this.$notification.notify(this.$store.state.lang.text.pleaseFill[this.$store.state.lang.language]);
				}
			},
		},
		computed: {
		},
		data() {
			return {
				isValid: false,
				loaded: false,
				message: "",
				user: {
					username: "",
					password: "",
					confirm_password: "",
					name: "",
					phone: "",
					token: "",
					verification_code: "", code: ""
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Register.vue